import cxs from 'cxs';

export const LIST_CONTAINER = (
{ loading, isMobile }) =>
cxs({
  height: '100vh',
  flex: loading ? 1 : 'initial',

  ...(isMobile ?
  {
    ' .list-container__content__item > .check-box': {
      height: '20px',
      minHeight: '20px',
      minWidth: '20px',
      width: '20px',
      marginRight: '10px'
    }
  } :
  {})

});